<div
    *ngIf="loading && isActive"
    [agprLoading]="loading"
    class="agpr-loadingOverlay"
>
</div>
<div
    [style.display]="selected ? '' : 'none'"
    role="tabpanel"
    [id]="id + '.panel'"
    [attr.aria-labelledby]="id"
    >
    <ng-template #tabHeader>
        @if (!hideBusinessCard) {
            <agpr-entity-business-card
                [id]="id + '_recentCoverageBusinessCard'"
                [isRHP]="true"
                [entity]="_entity"
                [canOpenFullProfile]="false"
                [contactPrivateData]="contactPrivateData"
                [outletPrivateData]="outletPrivateData"
                (selectedEmploymentChanged)="targetingRhpContextsService.changeSelectedEmployment($event.id)"
                [isCondensedMode]="true"
            ></agpr-entity-business-card>
        }
        <agpr-panel
            styleClass="agpr-recentCoverage-panel"
            [toggleable]="false"
            [contentPadding]="false"
            [noBorder]="true"
            [marginTop]="0"
        >
            <!-- top row -->
            <div
                class="agpr-recentCoverage-toolbar"
                [@toolbarCollapsed]=" toolbarStateService.toolbarCollapsed && !toolbarStateService.toolbarAnimationDisabled "
                (@toolbarCollapsed.start)="onAnimationStart($event)"
                (@toolbarCollapsed.done)="onAnimationDone($event)"
            >
                <div
                    class="agpr-recentCoverage-toolbar-row"
                    [ngClass]="{'agpr-recentCoverage-toolbar-row--chips': showFilterChips}"
                >
                    <agpr-filter-dropdown
                        id="resultsFilters"
                        [showQuickFilter]="true"
                        quickFilterPlaceholder="Discover.entityProfile.recentCoverage.filterPlaceholder"
                        [ariaLabel]="'Discover.entityProfile.recentCoverage.filterLabel' | localize"
                        ariaDescribedBy="resultsFilters.chips"
                    ></agpr-filter-dropdown>
                </div>
                <div
                    *ngIf="showFilterChips"
                    class="agpr-recentCoverage-toolbar-chips"
                >
                    <agpr-filter-chips
                        [id]="'resultsFilters.chips'"
                    ></agpr-filter-chips>
                </div>
            </div>
            <!-- bottom row -->
            <div
                *ngIf="userHasMonitoring"
                class="agpr-recentCoverage-toolbar-row agpr-recentCoverage-toolbar--bottom"
                [style.width]="toolbarStateService.toolbarCollapsed ? toolbarStateService.toolbarWidth + 'px' : '100%'"
            >
                <div
                    class="agpr-recentCoverage-toolbar-selectCheckbox"
                    [pTooltip]="(selectedMentions.length === mentions.length ? 'Monitoring.result.selectNone' : 'Monitoring.result.selectAll') | localize"
                >
                    <agpr-checkbox
                        id="targetingResult_recentCoverage_toggleSelectAll"
                        [binary]="true"
                        [label]="selectedMentions.length || '0'"
                        hiddenLabel="selectAll"
                        [disabled]="!mentions?.length"
                        [ngModel]="mentions.length > 0 && selectedMentions.length === mentions.length"
                        (ngModelChange)="toggleSelectAll()"
                    ></agpr-checkbox>
                </div>

                <agpr-dropdown
                    [id]="'recentCoverageTab-coverageSaveOptionDropdown'"
                    [options]="coverageSaveOptions"
                    [(ngModel)]="selectedCoverageSaveOption"
                    (ngModelChange)="clearCoverageSaveOption()"
                    ariaLabel="Discover.entityProfile.recentCoverage.saveCoverageToLabel"
                ></agpr-dropdown>

                <agpr-autocomplete
                    *ngIf="selectedCoverageSaveOption.value === coverageSaveOptionEnum.folder"
                    [id]="'recentCoverage.folderSelector'"
                    labelField="name"
                    placeholder="Monitoring.folderPicker.placeholder"
                    [dropdown]="true"
                    [(ngModel)]="dropdownFolder"
                    (clear)="dropdownFolder = null"
                    [customOptions]="folderAutocompleteOptions"
                    [suggestions]="folderList$"
                    [clearOnBlur]="false"
                    ariaLabel="Monitoring.source.type.folder"
                    panelStyleClass="p-autocomplete-panel-fullWidth"
                    [showHiddenOption]="true"
                ></agpr-autocomplete>

                <agpr-autocomplete
                    *ngIf="selectedCoverageSaveOption.value === coverageSaveOptionEnum.tag"
                    [id]="'recentCoverage.tagSelector'"
                    labelField="name"
                    placeholder="Monitoring.result.saveWithTags"
                    [dropdown]="true"
                    [(ngModel)]="selectedTags"
                    (itemSelected)="selectTag()"
                    [customOptions]="tagsAutocompleteOptions"
                    [suggestions]="tagList$"
                    [multiSelection]="true"
                    ariaLabel="Monitoring.source.type.tag"
                ></agpr-autocomplete>
                <div
                    *ngIf="mentions?.length && selectedMentions.length >= 1 && !actionBeingPerformed"
                    class="agpr-recentCoverage-toolbar-saveButton"
                >
                    <agpr-button
                        id="monitoringResult.saveSelectedMentions"
                        label="Monitoring.result.saveMentions"
                        [style]="buttonTypes.tertiary"
                        (click)="saveSelectedMentions()"
                    ></agpr-button>
                </div>
            </div>
            <div
                class="agpr-recentCoverage-toolbar-row"
                *ngIf="tagChips.length > 0 && userHasMonitoring"
                [@toolbarCollapsed]="{
                    value: toolbarStateService.toolbarCollapsed && !toolbarStateService.toolbarAnimationDisabled,
                    params: { height: 'auto' }
                }"
                (@toolbarCollapsed.start)="onAnimationStart($event)"
                (@toolbarCollapsed.done)="onAnimationDone($event)"
            >
                <agpr-chip-container
                    [id]="'monitoringResult.saveSettings.tags'"
                    [chips]="tagChips"
                    overflowMessage="Monitoring.result.saveSettings.tags.overflow"
                    emptyMessage="Monitoring.result.saveSettings.tags.empty"
                    (removeChip)="unselectTagChip($event)"
                ></agpr-chip-container>
            </div>
            <agpr-message
                *ngIf="mentions?.length === 0 && !mentionSearchService.searchedKeywords.getValue().length"
                [severity]="messageSeverities.noContent"
                [useWhiteBg]="true"
            >
                <span>
                    {{ 'Discover.influencerStreams.noCoverage' | localize }}
                </span>
            </agpr-message>

            <agpr-message
                *ngIf="mentions?.length === 0 && mentionSearchService.searchedKeywords.getValue().length > 0"
                [severity]="messageSeverities.noContent"
                [useWhiteBg]="true"
            >
                <span>
                    {{ 'Discover.entityProfile.recentCoverage.searchedKeywords.noContentMessage' | localize }}
                </span>
            </agpr-message>
        </agpr-panel>
    </ng-template>

    <ul
        [id]="id + '_mentionsList'"
        agprListKeyboardNavigation
        [list]="mentions"
    >
        <li *ngFor="let mention of mentions; let i = index">
            <div
                class="agpr-recentCoverage-card agpr-contextMenu-parent"
                [ngClass]="{'selected' : mention.selected}"
            >
                <div
                    class="agpr-recentCoverage-card-column center"
                >
                    @if ((mention?.showTranslated && mention?.translation)
                        || mention?.translation?.failedToTranslate
                        || (mention?.isTranslatedPreferred && mention?.translation)) {
                        <div class="agpr-recentCoverage-card-showTranslated">
                            <agpr-mention-language-display
                                [mention]="mention"
                                [showLanguageLabel]="true"
                            ></agpr-mention-language-display>
                        </div>
                    }
                    <div class="agpr-recentCoverage-card-author">
                        @if (userHasMonitoring) {
                            <div
                                class="agpr-recentCoverage-card-checkbox"
                            >
                                <agpr-checkbox
                                    [id]="id + '_mentionCheckbox_' + i"
                                    [value]="mention"
                                    [hiddenLabel]="'Discover.entityProfile.recentCoverage.mentionCard' | localize: {headline: ((mention?.isTranslatedPreferred || mention?.showTranslated) && mention?.translation?.headline) ? mention.translation.headline : mention.headline}"
                                    [(ngModel)]="selectedMentions"
                                    (onChange)="mentionSelected(mention)"
                                ></agpr-checkbox>
                            </div>
                        }
                        <div class="agpr-recentCoverage-card-AvatarWrapper">
                            <img
                                class="agpr-recentCoverage-card-entityAvatar"
                                [agprImageSrc]="mention.avatarUrl || mention.socialAvatarUrl"
                                alt=""
                                [agprDefaultImage]="entityType === entityTypeEnum.OUTLET ? imageDefault.SMALL_OUTLET : imageDefault.SMALL_CONTACT"
                            />
                        </div>
                        <div class="agpr-recentCoverage-card-NameWrapper">
                            @if (mention.handle) {
                                @if (mention.youtubeHandle && mention?.mediaType.id === mediaTypeEnum.YOUTUBE) {
                                    <div
                                        class="agpr-recentCoverage-card-entityName"
                                        [innerHTML]="mention.youtubeHandle | mentionLinks:mention.mediaType.id"
                                        agprTooltip="Mention.contactLink.tooltip"
                                        tooltipPosition="top"
                                    >
                                        <span
                                            role="img"
                                            class="fa-solid fa-user agpr-recentCoverage-card-entityName-icon"
                                            [attr.aria-label]="'Mention.contactLinkIcon'"
                                        ></span>
                                    </div>
                                } @else {
                                    <div
                                        class="agpr-recentCoverage-card-entityName"
                                        [innerHTML]="mention.handle | mentionLinks:mention.mediaType.id"
                                        agprTooltip="Mention.contactLink.tooltip"
                                        tooltipPosition="top"
                                    >
                                        <span
                                            role="img"
                                            class="fa-solid fa-user agpr-recentCoverage-card-entityName-icon"
                                            [attr.aria-label]="'Mention.contactLinkIcon'"
                                        ></span>
                                    </div>
                                }
                            } @else {
                                <agpr-button
                                    class="agpr-recentCoverage-card-entityName"
                                    [style]="buttonTypes.link"
                                    [initiallyFocusable]="i === 0"
                                    agprTooltip="Mention.outletLink.tooltip"
                                    tooltipPosition="top"
                                    (click)="onOutletClick(mention.publication?.uuid)"
                                >
                                    {{ mention.publication?.name }}
                                    <span
                                        role="img"
                                        class="fa-kit fa-agpr-outlet-solid agpr-recentCoverage-card-entityName-icon"
                                        [attr.aria-label]="'Mention.outletLink.tooltip'"
                                    ></span>
                                </agpr-button>
                            }


                            <div> {{ mention.author.name }} </div>
                        </div>
                        <div class="agpr-recentCoverage-card-mediaType">
                            <!-- TODO : put this in?
                            *ngIf="!mention.isLexisNexis; else lexisNexisLogo"
                            -->
                            <span
                                role="img"
                                [ngClass]="mention.mediaType.icon"
                                [agprTooltip]="mention.mediaType.tooltip"
                                tooltipPosition="left"
                                [initiallyFocusable]="i === 0"
                            ></span>
                        </div>
                    </div>
                    <div class="agpr-recentCoverage-card-mentionHeadline">
                        @if (mention.isCla) {
                            <img
                                src="assets/images/cla.jpg"
                                [alt]="'MediaType.cla.logo' | localize"
                                class="agpr-mention-mediaTypeIcon agpr-recentCoverage-card-mediaTypeIcon--cla"
                                agprTooltip="MediaType.cla"
                                tooltipPosition="left"
                            />
                        }
                        @if (mention.isNla) {
                            <img
                                src="assets/images/nla.jpg"
                                [alt]="'MediaType.nla.logo' | localize"
                                class="agpr-mention-mediaTypeIcon agpr-recentCoverage-card-mediaTypeIcon--nla"
                                agprTooltip="MediaType.nla"
                                tooltipPosition="left"
                            />
                        }
                        @if (mentionLinksEnabled && mention.url) {
                            <a
                                [href]="mention.url"
                                target="_blank"
                                class="agpr-recentCoverage-card-mentionHeadlineLink"
                            >
                                @if ((mention?.isTranslatedPreferred || mention?.showTranslated) && mention?.translation?.headline) {
                                    <span
                                        [innerHTML]="mention.translation.headline | indexHighlight: mention?.translation?.headlineHighlightIndexes : highlightKeywords | indexHighlightSup"
                                    ></span>
                                }
                                @else {
                                    <span
                                        [innerHTML]="mention.headline | highlightKeywords: highlightKeywords"
                                    ></span>
                                }
                            </a>
                        } @else {
                            @if ((mention?.isTranslatedPreferred || mention?.showTranslated) && mention?.translation?.headline) {
                                <span
                                    class="agpr-recentCoverage-card-mentionHeadlineLink"
                                    [innerHTML]="mention.translation.headline | indexHighlight: mention?.translation?.headlineHighlightIndexes : highlightKeywords | indexHighlightSup"
                                ></span>
                            }
                            @else {
                                <span
                                    class="agpr-recentCoverage-card-mentionHeadlineLink"
                                    [innerHTML]="mention.headline | highlightKeywords: highlightKeywords"
                                ></span>
                            }
                        }
                        @if ((mention.isCla || mention.isNla) && !mention.url) {
                            <span
                                class="fa-solid fa-key agpr-recentCoverage-card-mentionHeadlineLink-mentionLockIcon"
                                [agprTooltip]="'Mention.tooltip.unlock' | localize:{ licenseType: mention.isCla ? 'CLA' : 'NLA' }"
                                (click)="unlockMentionClicked([mention])"
                            ></span>
                        }
                    </div>
                    <div class="agpr-recentCoverage-card-mentionBody">
                        @if (mention.mediaType.id === mediaTypeEnum.TWITTER) {
                            @if ((mention?.isTranslatedPreferred || mention?.showTranslated) && mention?.translation?.body) {
                                <span [innerHTML]="mention.translation.body
                                    | indexHighlight: mention?.translation?.bodyHighlightIndexes: highlightKeywords
                                    | mentionLinks: mention.mediaType.id
                                    | indexHighlightSup"
                                ></span>
                            } @else {
                                <span [innerHTML]="mention.body
                                    | indexHighlight: mention.contexualKeywordIndices : highlightKeywords
                                    | mentionLinks: mention.mediaType.id
                                    | indexHighlightSup"
                                ></span>
                            }
                        } @else {
                            @if ((mention?.isTranslatedPreferred || mention?.showTranslated) && mention?.translation?.body) {
                                <span [innerHTML]="mention.translation.body
                                    | indexHighlight: mention?.translation?.bodyHighlightIndexes: highlightKeywords
                                    | mentionLinks: mention.mediaType.id
                                    | indexHighlightSup
                                    | filterStringByIndex: mention?.translation?.bodyHighlightIndexes?.[0] : 30"
                                ></span>
                            } @else {
                                <span [innerHTML]="mention.body
                                    | indexHighlight: mention.contexualKeywordIndices : highlightKeywords
                                    | mentionLinks: mention.mediaType.id
                                    | indexHighlightSup
                                    | filterStringByIndex: mention.contexualKeywordIndices[0]: 30"
                                ></span>
                            }
                        }
                    </div>

                    <div
                        class="agpr-recentCoverage-card-imageContainer"
                        *ngIf="mention.images.length > 0"
                    >
                        <a
                            *ngIf="mentionLinksEnabled"
                            [href]="mention.url"
                            target="_blank"
                        >
                            <img
                                class="agpr-recentCoverage-card-image"
                                [src]="mention.images[0].source"
                                [alt]="'Discover.entityProfile.recentCoverage.mentionImage.alt' | localize"
                                (error)="mention.images[0].source=undefined"
                            />
                        </a>
                        <img
                            *ngIf="!mentionLinksEnabled"
                            class="agpr-recentCoverage-card-image"
                            [src]="mention.images[0].source"
                            [alt]="'Discover.entityProfile.recentCoverage.mentionImage.alt' | localize"
                            (error)="mention.images[0].source=undefined"
                        />
                    </div>
                    <div *ngIf="mention.images.length === 0 && mention.thumbnailUrl">
                        <a
                            *ngIf="mentionLinksEnabled"
                            [href]="mention.url"
                            target="_blank"
                        >
                            <img
                                class="agpr-recentCoverage-card-image"
                                [src]="mention.thumbnailUrl"
                                [alt]="'Discover.entityProfile.recentCoverage.mentionThumbnail.alt' | localize"
                                (error)="mention.thumbnailUrl=undefined"
                            />
                        </a>
                        <img
                            *ngIf="!mentionLinksEnabled"
                            class="agpr-recentCoverage-card-image"
                            [src]="mention.thumbnailUrl"
                            [alt]="'Discover.entityProfile.recentCoverage.mentionThumbnail.alt' | localize"
                            (error)="mention.thumbnailUrl=undefined"
                        />
                    </div>
                </div>
                <div
                    class="agpr-recentCoverage-card-timestamp"
                    [pTooltip]="mention.datePublished | changeTimeZone: preferences.timeZone: preferences.getDateFormatString(true, true, true)"
                    tooltipPosition="top"
                >
                    {{mention.fromNowTimestamp}}
                </div>
                <div class="agpr-recentCoverage-card-contextMenu">
                    <div class="agpr-contextMenu bottom right">
                        @if(openAiPermission &&
                            !mention.isTranslatedPreferred &&
                            !mention.isFinancialTimes &&
                            mention?.languageModel?.name &&
                            ((mention?.languageModel?.name | localize) !== userLanguage)
                        ) {
                            <agpr-button
                                [style]="buttonTypes.contextMenu"
                                [id]="'quick-translate-' + mention?.id"
                                class="agpr-recentCoverage-card-contextMenu-button"
                                [icon]="'fa-kit-duotone fa-agpr-translate'"
                                [disabled]="concurrentTranslation >= maxConcurrentTranslation || mention.translating"
                                [tooltip]="(concurrentTranslation >= maxConcurrentTranslation)
                                    ? ('Mention.translate.tooManyRequests' | localize : {max : maxConcurrentTranslation})
                                    : mention.translating
                                        ? 'Mention.translating'
                                        : ('Mention.translateTo' | localize: {language: mention?.showTranslated ? ('Language.' + mention?.language | localize) : userLanguage})"
                                tooltipPosition="top"
                                (click)="mention?.showTranslated ? revertTranslate(mention) : translate(mention)"
                                [loading]="mention.translating"
                            ></agpr-button>
                        }
                        <agpr-button
                            #contextButton
                            [id]="'recentCoverageCard-' + id + '-shareButton_' + i"
                            *ngIf="mention.shareable"
                            (click)="showMediaSharing($event, contextButton)"
                            class="agpr-recentCoverage-card-contextMenu-button"
                            [tooltip]="'Discover.entityProfile.recentCoverage.shareButton'"
                            [icon]="'fa-regular fa-duotone fa-share-nodes'"
                            ariaHasPopup="true"
                            [style]="buttonTypes.contextMenu"
                        >
                        </agpr-button>
                    </div>
                    <p-popover
                        #mediaPlatformSharingSelector
                        [ngClass]="{'agpr-recentCoverage-sharePanel': !!mention.sharingInformation.facebook,
                                    'agpr-recentCoverage-sharePanel-emailOnly': !mention.sharingInformation.facebook}"
                        appendTo="body"
                    >
                        <agpr-content-sharing
                            id="recentCoverageCard_contentSharing"
                            [content]="mention.sharingInformation"
                            (escape)="hideMediaSharing()"
                        ></agpr-content-sharing>
                    </p-popover>
                </div>
            </div>
        </li>
        <div
            class="agpr-recentCoverage-subscribeOverlay"
            *ngIf="!userHasMonitoring && !hideUpsellForReseller"
        >
            <span
                class="fa-kit-duotone fa-agpr-hype-topics agpr-recentCoverage-subscribeOverlay-icon"
                aria-hidden="true"
            ></span>
            <div>{{'Discover.entityProfile.recentCoverage.contactMessage' | localize}}</div>
            <agpr-button
                id="recentCoverage.contactButton"
                label="Discover.entityProfile.recentCoverage.subscribeNow"
                [style]="buttonTypes.primary"
                (click)="navigateToSubscription()"
            ></agpr-button>
        </div>
    </ul>
    <ng-template #tabFooter>
        <agpr-action-bar
            *ngIf="userHasMonitoring"
            [headingContext]="'Discover.targeting.rhp.tabs.recentCoverage' | localize"
            headingLevel="4"
        >
            <ng-template #right>
                <agpr-button
                    label="Discover.entityProfile.monitorButton"
                    [style]="buttonTypes.tertiary"
                    (click)="navigateToMonitoring()"
                ></agpr-button>
            </ng-template>
        </agpr-action-bar>
    </ng-template>
</div>
